export default __webpack_public_path__ + "static/media/Strap CT Correct.1f663d09.mp4";